import { sortingTypes } from 'as-ui-kit/const';

export const countWhere = (array, filter) => {
    let count = 0;
    for (let i = 0; i < array.length; i++) {
        if (filter(array[i])) {
            count++;
        }
    }
    return count;
};

export const getEntityPosition = (entities, entityId, idField = 'Id') => {
    let selector = idField;
    if (typeof idField === 'undefined') {
        selector = el => el.Id;
    } else if (typeof idField !== 'function') {
        selector = el => el[idField];
    }

    return entities.findIndex(entity => selector(entity) === entityId);
};

/**
 * Среднее значение элементов массива чисел.
 * @param {number[]} array
 */
export const average = array => {
    if (!array?.length) return null;
    return array.reduce((prev, curr) => prev + curr, 0) / array.length;
};

const sortingFunctions = {
    strings: {
        [sortingTypes.ascending]: (fieldA, fieldB) => fieldA.localeCompare(fieldB, [], { sensitivity: 'base' }),
        [sortingTypes.descending]: (fieldA, fieldB) => fieldB.localeCompare(fieldA, [], { sensitivity: 'base' }),
    },
    numeric: {
        [sortingTypes.ascending]: (fieldA, fieldB) => fieldA - fieldB,
        [sortingTypes.descending]: (fieldA, fieldB) => fieldB - fieldA,
    },
};

/**
 * Сортирует массив объектов по строковому полю.
 * @param {object[]} array массив объектов
 * @param {string} field поле, по которому сортируем
 * @param {sortingTypes} sortType порядок сортировки
 */
export const sortByString = (array, field, sortType) =>
    array.sort(({ [field]: fieldA }, { [field]: fieldB }) => sortingFunctions.strings[sortType](fieldA, fieldB));

/**
 * Сортирует массив объектов по числовому полю.
 * @param {object[]} array массив объектов
 * @param {string} field поле, по которому сортируем
 * @param {sortingTypes} sortType порядок сортировки
 */
export const sortByNumeric = (array, field, sortType) =>
    array.sort(({ [field]: fieldA }, { [field]: fieldB }) => sortingFunctions.numeric[sortType](fieldA, fieldB));

/**
 * Убирает из массива falsy элементы
 * @param {Array} array
 */
export const filterExisting = array => array.filter(Boolean);

/**
 * Группировка массива по некоторому ключу
 * @param {Array<Object<string, object>>} array
 * @param {string} key
 */
export const groupBy = (array, key) =>
    array.reduce((result, current) => {
        result[current[key]] = current;
        return result;
    }, {});

export const circular = (length, next) => {
    if (next >= 0 && next < length) {
        return next;
    }

    const mod = next % length;
    return mod >= 0 ? mod : length + mod;
};
